export enum HelpDeskInputFieldEnum {
  netWeight = 'product net weight',
  grossWeight = 'product gross weight',
  temperatureControl = 'Temperature Control',
  reportingPeriodProduction = 'Reporting Period Production',
  productCOGSRatio = 'product COGS ratio',
  reportingPeriod = 'Reporting Period',
  reportingYear = 'Reporting Year',
  processingFacilityName = 'processing facility name',
  productDensity = 'product density',
  pfScope1 = 'Processing Facility Scope 1 CF',
  pfScope2 = 'Processing Facility Scope 2 CF',
  diesel = 'Diesel',
  naturalGas = 'Natural Gas',
  gasoline = 'Gasoline',
  wood = 'Wood',
  purchasedCo2 = 'Purchased CO2',
  heatingOil = 'Heating Oil',
  refrigerant = 'Refrigerant',
  propane = 'Propane',
  electricity = 'Electricity',
  lightFuelOil = 'Light Fuel Oil',
  heavyFuelOil = 'Heavy Fuel Oil',
  coal = 'coal',
  NATURAL_GAS = 'natural_gas',
  productTotalWeight = 'Total Weight Of All Products Produced',
  revenue = 'Production Revenue',
  totalWasteProduced = 'Total Waste Produced',
  totalWasteWater = 'Total Waste Water',
  wasteType = 'Waste Type',
  wasteTreatmentMethod = 'Waste Treatment Method',
  organizationName = 'Organization name',
  organizationSize = 'Organization size',
  organizationSector = 'Sector',
  organizationCompanyType = 'Company Type',
  organizationBoundary = 'Organizational Boundary',
  reportingDetailsYear = 'Start of your reporting year',
  reportingDetailsBaselineYear = 'Baseline year',
  reportingDetailsThreshold = 'Baseline year recalculation threshold (%)',
  locationName = 'Location name',
  locationCategory = 'Location category',
  locationAddress = 'Address',
  stationaryCombustion = 'Stationary combustion',
  mobileSources = 'Mobile combustion',
  processSources = 'Process sources',
  fugitiveEmissions = 'Fugitive emissions',
  DQR = 'Data Quality Rating',
  refrigerantFieldName = 'refrigerant',
  targetInitiative = 'Climate Target',
  targetName = 'Target Name',
  isSME = 'Are you an SME as per SBTi eligibility criteria?',
  selectTarget = 'Select Target',
  selectOrganization = 'Select Organization',
  targetCoverage = 'Target Coverage',
  targetSettingMethod = 'Target setting method',
  baselineYear = 'Baseline year',
  targetYear = 'Target year',
  notes = 'Notes',
  totalReduction = 'Total reduction (%)',
}
